export const initial = {
  step: 0,
  numberOfSteps: 1,
  submitting: false,
  fieldNames: [],
  stepsVisited: [false],
  stepsValid: [false],
};

export const test = {
  step: 0,
  numberOfSteps: 1,
  submitting: true,
  fieldNames: [],
  stepsVisited: [false],
  stepsValid: [false],
};
